module.exports = __webpack_public_path__ + "img/bg_teachers_day.ff381a07.png";